import Vue from 'vue';
import VueRouter from 'vue-router';
import SessionService from "@/services/Session/Session.service";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    name: "Error404",
    component: () => import(/* webpackPrefetch: true */ '@/views/Error404'),
    meta: { title: 'Caldeira® | Erro 404', requiresAuth: false }
  },
  {
    path: '/',
    name: 'Login',
    component: () => import(/* webpackPrefetch: true */ '@/views/Login'),
    meta: { title: 'Caldeira® | Login', requiresAuth: false }
  },
  {
    path: '/perfil',
    name: 'Perfil',
    component: () => import(/* webpackPrefetch: true */ '@/views/Perfil'),
    meta: { title: 'Caldeira® | Perfil', requiresAuth: true }
  },
  {
    path: '/empresa',
    name: 'Empresa',
    component: () => import(/* webpackPrefetch: true */ '@/views/Empresas'),
    meta: { title: 'Caldeira® | Empresa', requiresAuth: true }
  },
  {
    path: '/colaboradores',
    name: 'Colaboradores',
    component: () => import(/* webpackPrefetch: true */ '@/views/Colaboradores'),
    meta: { title: 'Caldeira® | Colaboradores', requiresAuth: true }
  },
  {
    path: '/visitantes',
    name: 'Visitantes',
    component: () => import(/* webpackPrefetch: true */ '@/views/Visitantes'),
    meta: { title: 'Caldeira® | Visitantes', requiresAuth: true }
  },
  {
    path: '/alunos/:id?',
    name: 'Alunos',
    component: () => import(/* webpackPrefetch: true */ '@/views/Alunos'),
    meta: { title: 'Caldeira® | Alunos', requiresAuth: true }
  },
  {
    path: '/portaria/:id?',
    name: 'Portaria',
    component: () => import(/* webpackPrefetch: true */ '@/views/Portaria'),
    meta: { title: 'Caldeira® | Portaria', requiresAuth: true }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import(/* webpackPrefetch: true */ '@/views/News'),
    meta: { title: 'Caldeira® | News', requiresAuth: true }
  },
  {
    path: '/gerenciadorSenhas/:token?',
    name: 'GerenciadorSenhas',
    component: () => import(/* webpackPrefetch: true */ '@/views/GerenciadorSenhas'),
    meta: { title: 'Caldeira® | Gerenciador de senha', requiresAuth: false }
  },

  {
    path: "/sucesso",
    name: "Sucesso",
    component: () => import(/* webpackPrefetch: true */ '@/views/Sucesso'),
    meta: { title: 'Caldeira® | Sucesso', requiresAuth: false }
  },
  {
    path: "/onboard/:token?",
    name: "Onboard",
    component: () => import(/* webpackPrefetch: true */ '@/views/Onboard'),
    meta: { title: 'Caldeira® | Onboard', requiresAuth: false }
  },
  {
    path: "/validacao",
    redirect: (to) => {
      return { path: "/onboard", query: to.query };
    },
    name: "Validacao",
    component: () => import(/* webpackPrefetch: true */ '@/views/ValidarDocumento'),
    meta: { title: 'Caldeira® | Validação', requiresAuth: false }
  },
  {
    path: '/bloqueio',
    name: 'Bloqueio',
    component: () => import(/* webpackPrefetch: true */ '@/views/Bloqueio'),
    meta: { title: 'Caldeira® | Bloqueio', requiresAuth: false }
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// ==================================================
// CONTROLE DE SESSÃO
// ==================================================

var auth = {
  loggedIn() {
    // faz o login e retorna como true caso fique logado
    // A rota deve ter  "meta: { requiresAuth: true }" para que só acesse com o login
    // essa variavel pode ser um prototype
    if (SessionService.exists()) {
      return true;
    } else {
      return false;
    }
  }
};
router.beforeEach((to, from, next) => {
  // define o titulo nas rotas
  document.title = to.meta.title;

  // Acessos para o logista
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.loggedIn()) {
      next({
        name: 'Login',
      });
    } else {
      // if(Vue.prototype.$Internet.validacao && to.name != 'Home'){
      //   next({
      //     name: 'Home',
      //   })
      //   return
      // }
      next();
    }
  } else {
    // if(Vue.prototype.$Internet.validacao && to.name != 'Home'){
    //   next({
    //     name: 'Home',
    //   })
    //   return
    // }
    next(); // make sure to always call next()!
  }

});

export default router;
